import { apiClient } from './client'

const basePath = (organizationId: string | number, deploymentId: string | number) =>
  `/organization/${organizationId}/deployment/${deploymentId}/recipe-schedule`

export interface RecipeSchedule {
  id: string
  name: string
  description?: string
  recipe_id?: string
  type: 'scheduled' | 'cron' | 'webhook' | string
  scheduled_time?: string | null
  cron_expression?: string | null
  webhook_url?: string
  enabled?: boolean
  last_run_at?: string | null
  created_at?: string
  updated_at?: string
}

export interface RecipeSchedulePayload {
  name: string
  description?: string
  recipe_id: string
  type: 'scheduled' | 'cron' | 'webhook' | string
  scheduled_time?: string | null
  cron_expression?: string | null
  payload?: Record<string, unknown>
  webhook_url?: string
  enabled?: boolean
}

export const recipeSchedulesAPI = {
  list: (organizationId: string | number, deploymentId: string | number) =>
    apiClient.get<RecipeSchedule[]>(basePath(organizationId, deploymentId)),

  create: (
    organizationId: string | number,
    deploymentId: string | number,
    payload: RecipeSchedulePayload,
  ) => apiClient.post<RecipeSchedule>(basePath(organizationId, deploymentId), payload),

  update: (
    organizationId: string | number,
    deploymentId: string | number,
    scheduleId: string | number,
    payload: Partial<RecipeSchedulePayload>,
  ) =>
    apiClient.put<RecipeSchedule>(
      `${basePath(organizationId, deploymentId)}/${scheduleId}`,
      payload,
    ),

  delete: (
    organizationId: string | number,
    deploymentId: string | number,
    scheduleId: string | number,
  ) => apiClient.delete<void>(`${basePath(organizationId, deploymentId)}/${scheduleId}`),

  run: (
    organizationId: string | number,
    deploymentId: string | number,
    scheduleId: string | number,
    payload?: Record<string, unknown>,
  ) =>
    apiClient.post<void>(`${basePath(organizationId, deploymentId)}/${scheduleId}/run`, {
      payload: payload || {},
    }),
}
